'use client';

import {useQuery} from '@tanstack/react-query';
import {getMonolithApiHeaders} from '@udemy-v2/api-fetch';

interface CourseLandingComponentsApiOptions {
    enabled?: boolean;
}

export function useCourseLandingComponentsApi<TResponse>(
    courseId: string | number,
    component: string,
    options: CourseLandingComponentsApiOptions = {},
) {
    return useQuery<TResponse>({
        queryKey: ['course-landing-components', String(courseId), component],
        queryFn: async () => {
            const response = await fetch(
                `/api-2.0/course-landing-components/${courseId}/me/?components=${component}`,
                {
                    headers: {
                        ...getMonolithApiHeaders(),
                        'Content-Type': 'application/json',
                    },
                },
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch course landing components: ${response.status} ${response.statusText}`,
                );
            }

            return response.json() as Promise<TResponse>;
        },
        enabled: options.enabled ?? true,
        retry: false,
    });
}
